export const ABS_ATTRIBUTES: string = "ABS Attributes";
export const LOADING_ABS: string = "Loading ABS Attribute Order";
export const LOADING_CF: string = "Loading CF Attribute Order";
export const SAVING_ABS: string = "Saving new order for Abs Attributes";
export const SAVING_CF: string = "Saving new order for Cf Attributes";
export const ABS_NOT_FOUND: string = "ABS Attributes Not Found";
export const CF_NOT_FOUND: string = "CF Attributes Not Found";
export const CF_ATTRIBUTES: string = "CF Attributes";
export const ACCORDION_FLUSH_ABS: string = "accordionFlushAbs";
export const ACCORDION_FLUSH_CF: string = "accordionFlushCf";
export const ACCORDION_FLUSH_COLLAPSE_ABS: string = "#flush-collapseAbs";
export const ACCORDION_FLUSH_COLLAPSE_CF: string = "#flush-collapseCf";